// Shared wording/helpers for the device assign flows (patient profile dialog, Devices > Assign screen).
export const FOREIGN_DEVICE_MESSAGE = 'This device belongs to another practice/patient — contact your Org Manager';

export const DEVICE_TYPES = [
    { value: 'bp', label: 'BP cuff' },
    { value: 'weight', label: 'Weight scale' },
    { value: 'spO2', label: 'Pulse oximeter (SpO2)' },
];

export const errorText = (e) => e?.response?.data?.message || e?.message || 'Request failed';

/** Lookup 404 for an IMEI that is not in inventory yet (offer Register & assign). */
export const isUnknownDevice = (e) => e?.response?.status === 404 && /unknown device/i.test(e?.response?.data?.message || '');

/** True when a request path contains a literal "undefined"/"null" segment (an id that was never set). */
export const hasMissingIdSegment = (url) => {
    const path = String(url || '').split('?')[0].replace(/^https?:\/\/[^/]+/i, '');
    return path.split('/').some((seg) => seg === 'undefined' || seg === 'null');
};
